module.exports = __webpack_public_path__ + "img/closet_background2.3087e379.png";